import React, { Fragment, useEffect, useState } from "react";
import Humberg from "../../elements/Humberg.jsx";
import { allAdminsAction, clearErrors, InviteUserAction } from "../../redux/actions/userActions.js";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { INVITE_USER_RESET } from "../../redux/constants/userConstant.js";
import Loader from "../loader/loader.jsx";


/*************  ✨ Windsurf Command ⭐  *************/
/**

/*******  5b7ebdaf-643b-4a2c-9103-b2439c904928  *******/
const AddUser = () => {


    const dispatch = useDispatch();




    const [email, setemail] = useState('')
    const [role, setRole] = useState('')
    const [admin_id, setAdmin_id] = useState('')
    const [referral_id, setReferral_id] = useState('')


    const { loading, error, message } = useSelector(state => state.inviteUser)
    const { user } = useSelector(state => state.verifyEmailStore)
    const { loading: userLoading, admins } = useSelector((state) => state.getUsers)



    useEffect(() => {
        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("dashboard")
        const subElement = document.getElementById("invite-users");


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");
        console.log(subElement)
        subElement?.classList.add("activeSubLink");

        document.title = `Invite Users`;

    }, []);
    // Remove one quantity


    const handleSubmit = (e) => {
        e.preventDefault();



        if (!email) {
            toast.error("Please enter your email");
            return;
        }

        if (!role) {
            toast.error("Please select role");
            return;
        }


        const userData = {
            email: email,
            role: role,
            admin_id: admin_id,
            referral_id: referral_id
        }

        dispatch(InviteUserAction(userData))


    }



    useEffect(() => {

        if (message) {
            dispatch({ type: INVITE_USER_RESET })
            setemail('');
            setRole('');
            setAdmin_id('');
        }

        if (error) {
            dispatch(clearErrors());
        }

    }, [error, dispatch, message])







    useEffect(() => {

        let query = {}
        query.status = "ACTIVE"
        query.perPage = 100

        dispatch(allAdminsAction(query))

    }, [dispatch])


    return (
        <Fragment>
            <Humberg header="Dashboard" headerLink="/" children={"Invite Users"} />
            {(loading || userLoading) && <Loader />}
            <section className="p-[1vmax_1.5vmax]" >
                <div className="bg-white shadow-sm rounded-xl p-[2vmax] border border-gray-100">
                    <form onSubmit={handleSubmit} >
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[1.5vmax] items-end" >
                            
                            {/* User Email */}
                            <div className="flex flex-col gap-[0.5vmax]" >
                                <label className="text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider">
                                    User Email <span className="text-red-500">*</span>
                                </label>
                                <input 
                                    type="email" 
                                    className="w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] font-medium text-gray-700" 
                                    placeholder="Enter User Email"
                                    value={email} 
                                    onChange={(e) => setemail(e.target.value)}
                                />
                            </div>

                            {/* Assign Role */}
                            <div className="flex flex-col gap-[0.5vmax]" >
                                <label className="text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider">
                                    Assign Role <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                    <select 
                                        className="w-full pl-[1vmax] pr-[2vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] appearance-none font-medium text-gray-700"
                                        value={role} 
                                        onChange={(e) => setRole(e.target.value)}
                                    >
                                        <option value="" >-- Select Option</option>
                                        {user?.role !== 'ADMIN' &&
                                            <option value="ADMIN" >ADMIN</option>
                                        }
                                        <option value="PMM" >PMM</option>
                                        <option value="PM" >PM</option>
                                    </select>
                                    <span className="absolute right-[1vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                        <i className="fa-solid fa-chevron-down text-xs"></i>
                                    </span>
                                </div>
                            </div>

                            {/* Assign Admin (Conditional) */}
                            {role && (role === 'PMM' && user?.role !== 'ADMIN') && (
                                <div className="flex flex-col gap-[0.5vmax]" >
                                    <label className="text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider">
                                        Assign Admin <span className="text-red-500">*</span>
                                    </label>
                                    <div className="relative">
                                        <select 
                                            className="w-full pl-[1vmax] pr-[2vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] appearance-none font-medium text-gray-700"
                                            value={admin_id} 
                                            onChange={(e) => setAdmin_id(e.target.value)}
                                        >
                                            <option value="" >-- Select Admin</option>
                                            {admins?.length > 0 ?
                                                admins?.map((admin) => (
                                                    <option key={admin?.id} value={admin?.id}>
                                                        ID: {admin?.id} | {admin?.name}
                                                    </option>
                                                ))
                                                :
                                                <option value="" >No Admin Found</option>
                                            }
                                        </select>
                                        <span className="absolute right-[1vmax] top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                                            <i className="fa-solid fa-chevron-down text-xs"></i>
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Referral ID */}
                            <div className="flex flex-col gap-[0.5vmax]" >
                                <label className="text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider">
                                    Referral ID
                                </label>
                                <input 
                                    type="number" 
                                    className="w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] font-medium text-gray-700" 
                                    placeholder="Enter Referral ID"
                                    value={referral_id} 
                                    onChange={(e) => setReferral_id(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Footer Section */}
                        <div className="flex justify-between mt-[2vmax] items-center flex-wrap gap-[1vmax]" >
                            <p className="text-[0.9vmax] text-gray-500 italic" >
                                <i className="fa-solid fa-circle-info mr-1"></i>
                                The invitation request will expire within 24 hours after sending.
                            </p>
                            <div className="flex gap-3 justify-end items-center">
                                <button 
                                    className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-[2vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors"
                                    type="reset"
                                >
                                    Reset
                                </button>
                                <button 
                                    className={`bg-indigo-600 hover:bg-indigo-700 text-white px-[2vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed`}
                                    type="submit"
                                    disabled={email === "" || role === "" || loading}
                                >
                                    {loading ? "Sending..." : "Send Invite"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </Fragment>
    );
};

export default AddUser;
